@let objectType = activityObjectType();
<div #scrollableContainerRef class="activity-timeline-container activity-timeline-container-with-views">
  @if (objectType) {
    <crm-activity-logger
      [crmObjectId]="crmObjectId()"
      [objectType]="objectType"
      (activityCreated)="addActivity($event)"
      class="logger"
    ></crm-activity-logger>
  }

  @if (enableAISummary() && !enableNewActivityFeed() && resolvedAiSummaryComponent() && objectType) {
    <ng-container
      [ngComponentOutlet]="resolvedAiSummaryComponent()"
      [ngComponentOutletInputs]="{ crmObjectId: crmObjectId(), crmObjectType: objectType }"
      class="summary"
    ></ng-container>
  }
  <crm-view-tabs
    [loading]="viewTabsLoading()"
    [tabGroups]="viewTabs$ | async"
    [tabTemplate]="newViewTemplate()"
    [editTabLabel]="'VIEW_TABS.EDIT_TABS' | translate"
    [editTabHint]="'VIEW_TABS.HINT' | translate"
    [nameRequiredError]="'VIEW_TABS.ERRORS.NAME_REQUIRED' | translate"
    [addTabText]="'VIEW_TABS.ADD_TAB' | translate"
    [savedOrder]="tabOrder$$ | async"
    (selectedTabChanged)="changeViewFilters($event.filters)"
    (tabsUpdated)="saveViewFilterTabChanges($event)"
    (tabsDeleted)="deleteViewFilters($event)"
    (orderUpdated)="saveTabOrder($event)"
    [scrollable]="false"
  >
    <div class="search-and-filter-container-with-views">
      <div class="search-and-filter-row-with-views">
        <div class="filter-search-group">
          <button
            mat-stroked-button
            class="filters-toggle"
            data-action="clicked-filters-toggle"
            [ngClass]="{ on: showFiltersOpen }"
            (click)="toggleFilterBar()"
          >
            <mat-icon class="filters-toggle--icon">
              filter_list
              @if (filtersApplied()) {
                <span class="filters-toggle--indicator"></span>
              }
            </mat-icon>
            <span class="filters-toggle--label">{{ 'GALAXY.TABLE.FILTERS.TOGGLE_BUTTON' | translate }}</span>
          </button>

          <glxy-form-field
            class="searchbar"
            suffixIcon="search"
            bottomSpacing="none"
            [ngClass]="{ 'darker-border': enableNewActivityFeed() }"
          >
            <input type="text" [placeholder]="'ACTIONS.SEARCH' | translate" matInput [formControl]="searchControl" />
          </glxy-form-field>
        </div>
        <mat-slide-toggle
          class="campaign-toggle-button"
          [checked]="excludeCampaignsOverride()"
          (change)="toggleExcludeCampaignsOverride()"
        >
          {{ 'VIEWS.PRESET_FILTERS.EXCLUDE_CAMPAIGNS' | translate }}
        </mat-slide-toggle>
      </div>
      <div class="filter-bar" [@openClose]="showFiltersOpen ? 'open' : 'closed'">
        <div class="filter-bar--inner-space">
          <glxy-filter-chips
            #filterChipRef
            [addFiltersHeader]="'ACTIVITY.TITLE' | translate"
            (filtersChanged)="updateFilters($event, false)"
            filters-area
          ></glxy-filter-chips>
        </div>
      </div>
    </div>
    <div class="activity-list">
      <crm-timeline
        #crmTimelineRef
        class="timeline"
        [crmObjectId]="crmObjectId()"
        [objectType]="objectType!"
        (activitiesChanged)="handleActivitiesChanged($event)"
        [showCopyLink]="true"
      ></crm-timeline>
    </div>
    @if (showLoadMore) {
      <glxy-infinite-scroll-trigger
        [visiblilityMargin]="10"
        (isVisible)="loadMoreActivities()"
      ></glxy-infinite-scroll-trigger>
    }
  </crm-view-tabs>
</div>
